import Individual from 'marketplace/entities/individual/individual';
import Company from 'marketplace/entities/company/company';
import BillingRateInfo from 'marketplace/values/billing-rate-info/billing-rate-info';
import CompanyProfile from 'marketplace/values/company-profile/company-profile';
import IndividualProfile from 'marketplace/values/individual-profile/individual-profile';
import InsuranceInfo from 'marketplace/values/insurance-info/insurance-info';
import MarketplaceResponseAPIResponse from 'marketplace/api/response-contracts/marketplace-response-api-response';
import EmailAddress from 'common/values/email-address/email-address';
import Guid from 'common/values/guid/guid';
import PhoneNumber from 'common/values/phone-number/phone-number';
import RegistrationNumber from 'marketplace/values/registration-number/registration-number';
import TechnicalBackgroundInfo from 'marketplace/values/technical-background-info/technical-background-info';
import AddressAPIResponse from 'common/api/response-contracts/address-api-response';

export default class MarketplaceIndividualInfoAPIResponse extends MarketplaceResponseAPIResponse {
  entityId?: string;
  companyId?: string;
  companyEntityId?: string;
  companyName?: string;
  firstName?: string;
  lastName?: string;
  description?: string;
  location?: AddressAPIResponse;
  phoneNumber?: string;
  school?: string;
  degree?: string;
  avatar?: string;
  emailAddress?: string;
  resume?: string;
  professionalRegistration?: string;
  technicalBackground?: string;
  numberOfApplicationsDraftedProsecuted?: number;
  numberOfAllowedApplications?: number;
  barAdmissionYear?: number;
  isOnCall?: boolean;
  insuredAmount?: number;
  billingRate?: string;
  billingUnit?: string;
  potentialDiversityCandidate?: boolean;
  collaborates?: boolean;
  additionalInfo?: string;
  links?: string[];
  professionalPublications?: string[];
  sampleApplications?: string[];
  fluentLanguages?: string[];
  technicalLanguages?: string[];
  regionsRegistered?: string[];
  regionsLicensed?: string[];
  categories?: string[];
  userId?: string;
  isVendorRep?: boolean;
  isClientRep?: boolean;

  deserialize(): Individual {
    if (!this.id) throw new Error("Individual Id is required");
    if (!this.userId) throw new Error("User Id is required");
    if (!this.firstName) throw new Error("First name is required");
    if (!this.lastName) throw new Error("Last name is required");
    if (!this.companyId) throw new Error("Company Id is required");
  

    const entityId = this.companyEntityId ?? this.entityId;    
    if (!entityId) throw new Error("Company Entity Id is required");

    const individualProfile = new IndividualProfile(
      new Guid(this.userId),
      this.firstName,
      this.lastName
    );
    const location = Object.assign(new AddressAPIResponse(), this.location);
    individualProfile.description = this.description;
    individualProfile.location = this.location ? location.deserialize() : undefined;
    individualProfile.phoneNumber = this.phoneNumber ? new PhoneNumber(this.phoneNumber) : undefined;
    individualProfile.school = this.school;
    individualProfile.degree = this.degree;
    individualProfile.avatarId = this.avatar ? new Guid(this.avatar) : undefined;
    individualProfile.email = this.emailAddress ? new EmailAddress(this.emailAddress) : undefined;
    individualProfile.resumeId = this.resume ? new Guid(this.resume) : undefined;
    individualProfile.professionalRegistration = this.professionalRegistration ? new RegistrationNumber(this.professionalRegistration) : undefined;
    individualProfile.technicalBackground = this.technicalBackground ? new TechnicalBackgroundInfo(this.technicalBackground) : undefined;
    individualProfile.numberOfApplicationsDraftedProsecuted = this.numberOfApplicationsDraftedProsecuted;
    individualProfile.numberOfAllowedApplications = this.numberOfAllowedApplications;
    individualProfile.barAdmissionYear = this.barAdmissionYear;
    individualProfile.isOnCall = this.isOnCall ?? false;
    individualProfile.insured = this.insuredAmount ? new InsuranceInfo(this.insuredAmount) : undefined;
    individualProfile.billingRate = this.billingRate ? new BillingRateInfo(this.billingRate, this.billingUnit ?? "") : undefined;
    individualProfile.potentialDiversityCandidate = this.potentialDiversityCandidate ?? false;
    individualProfile.collaborates = this.collaborates ?? false;
    individualProfile.additionalInfo = this.additionalInfo;
    individualProfile.links = this.links ?? [];
    individualProfile.professionalPublications = this.professionalPublications ?? [];
    individualProfile.sampleApplications = this.sampleApplications ?? [];
    individualProfile.fluentLanguages = this.fluentLanguages ?? [];
    individualProfile.technicalLanguages = this.technicalLanguages ?? [];
    individualProfile.administrativeRegions = this.regionsRegistered ?? [];
    individualProfile.regionsRegistered = this.regionsRegistered ?? [];
    individualProfile.regionsLicensed = this.regionsLicensed ?? [];
    individualProfile.categories = this.categories ?? [];


    const company = new Company(
      new Guid(this.companyId),
      new Guid(entityId),
      this.companyName ? new CompanyProfile(this.companyName) : undefined
    );

    return new Individual(new Guid(this.id), new Guid(this.userId), individualProfile, company, this.isVisible ?? false);
  }
}
